import { render } from "./CounterRecords.vue?vue&type=template&id=7c4b6d76&ts=true"
import script from "./CounterRecords.vue?vue&type=script&lang=ts"
export * from "./CounterRecords.vue?vue&type=script&lang=ts"

import "./CounterRecords.vue?vue&type=style&index=0&id=7c4b6d76&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__